import { ISignedDocumentResponse } from "@wingspanhq/signed-documents/dist/lib/interfaces";
import { serviceSignedDocuments } from "./serviceSignedDocuments";

export const getSignedDocument = async (
  id: string
): Promise<ISignedDocumentResponse> => {
  const { data } = await serviceSignedDocuments.get(`/${id}`);
  return data;
};
